<template>
  <div id="InsurancePolicy">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Insurance Policies</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'insurancePolicyReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'insurancePolicyReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Insurance Policy Report"
                  ref="insurancePolicyReport"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-select-all="onSelectAll"
                  @on-selected-rows-change="selectionChanged"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "InsurancePolicy",
  metaInfo() {
            return {title: "Insurance Policy Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
                {
                    label: 'Company Code',
                    field: 'ins_company_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Insurance Company Name',
                    field: 'ins_company',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Policy Number',
                    field: 'policy_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Blanket Policy',
                    field: 'blanket_policy',
                    hidden:false,
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Blanket Policy", // placeholder for filter input
                        filterDropdownItems: ['Y','N','L','R'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    fpFieldType:"custom_date",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"custom_date",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Agent Name',
                    field: 'agent_name',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Agent Contact',
                    field: 'agent_contact',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Agent Phone',
                    field: 'agent_phone',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Agent Fax',
                    field: 'agent_fax',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Customer Number',
                    field: 'customer_number',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Customer Phone #',
                    field: 'cus_phn',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                },
                    {
                    label: 'Customer Status',
                    field: 'customer_status',
                    hidden:false,
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Status", // placeholder for filter input
                        filterDropdownItems: ['A','I'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Active Contracts',
                    field: 'active_contracts',
                    hidden:false,
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Active Contracts", // placeholder for filter input
                        filterDropdownItems: ['Y','N'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Ins Section 1',
                    field: 'ins_sectn1',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Section 1 Deductible',
                    field: 'collision',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                },
                {
                    label: 'Section 1 Liability Limit',
                    field: 'sectn1_liability',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                    sortable:false
                },
                {
                    label: 'Ins Section 2',
                    field: 'ins_sectn2',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Section 2 Deductible',
                    field: 'comprehensive',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                },
                {
                    label: 'Section 2 Liability Limit',
                    field: 'sectn2_liability',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                    sortable:false
                },
                {
                    label: 'Ins Section 3',
                    field: 'ins_sectn3',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'Section 3 Deductible',
                    field: 'sectn3_deductible',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                    sortable:false
                },
                {
                    label: 'Section 3 Liability Limit',
                    field: 'liability',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                },
                {
                    label: '# of Active Contracts',
                    field: 'total_active_contracts',
                    fpFieldType:"integer",
                    html: false,
                    filterable: true,
                    hidden:false,
                    sortable: true,
                },
                {
                    label: '# of Contracts(Last 12 Months)',
                    field: 'active_contract_last_12_months',
                    fpFieldType:"integer",
                    html: false,
                    filterable: true,
                    hidden:false,
                    sortable:true,
                },
                {
                    label: 'Ins Comment',
                    field: 'comments',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Sales Rep',
                    field: 'sales_rep_name',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    sortable:true
                },
                {
                    label: 'Sales Rep Code',
                    field: 'sales_rep_code',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    sortable:true
                },


      ],
    batchProcess:0,
    batchNum:"",

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'insurance_policy_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.insurancePolicyReport.unselectAllInternal();
    },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['insurancePolicyReport'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['insurancePolicyReport'].selectedRows[i].id)
      }


      $.ajax({
        url: process.env.ROOT_API + "/insurance-policy-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;


          if (data.status == "success") {

            if ( self.action == "export" ||  self.action == "export_queue") {

              if ( data.code == "201" ) {
                  alert(data.message);
              } else {

                  if ( self.action == "export" ) {

                      self.excel = data.content.web;
                      var save = document.createElement("a");
                      save.href = self.excel;
                      save.download = data.content.web;
                      save.target = "_blank";

                      document.body.appendChild(save);
                      save.click();
                      document.body.removeChild(save);

                  } else {

                      self.batchProcess = 1;
                      self.batchNum = data.content;
                  }

              }

              self.action = "list";
              self.loadList();
              return;

            } else {
             if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/InsurancePolicyReport.vue